__turbopack_context__.v({
  "actionButton": "PageTitle-module-scss-module__PPOAYG__actionButton",
  "counter": "PageTitle-module-scss-module__PPOAYG__counter",
  "description": "PageTitle-module-scss-module__PPOAYG__description",
  "inlineWrapper": "PageTitle-module-scss-module__PPOAYG__inlineWrapper",
  "leftSection": "PageTitle-module-scss-module__PPOAYG__leftSection",
  "reloadButton": "PageTitle-module-scss-module__PPOAYG__reloadButton",
  "title": "PageTitle-module-scss-module__PPOAYG__title",
  "titleRow": "PageTitle-module-scss-module__PPOAYG__titleRow",
  "wrapper": "PageTitle-module-scss-module__PPOAYG__wrapper",
});
